// @flow
import React, { Component, Fragment } from "react";
import Divider from "@material-ui/core/Divider";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";

type NavbarMenuGroupPropType = {
  subHeader: React$Element<*>,
  subLists: React$Element<*>,
  open: boolean
};

class NavbarMenuGroup extends Component<*, NavbarMenuGroupPropType> {
  render(): React$Element<*> {
    return (
      <Fragment>
        {this.props.subHeader}
        <Collapse in={this.props.open} timeout="auto">
          <List>{this.props.subLists}</List>
          <Divider />
        </Collapse>
      </Fragment>
    );
  }
}

export default NavbarMenuGroup;
